<footer class="footer-area footer-bg">
    <div class="footer-middle pt-100 pb-70">
        <div class="container">
            <div class="row" style="align-items: baseline;">
                <div class="col-lg-6 col-md-6">
                   <div class="footer-widget">

                    <p class="footer-name">Other Links</p>
                        <ul class="footer-contact-list">
                            <li><span>FAQ'S</span> </li> 
                            <li><span>Sitemap</span> </li> 
                            <li><span>Privacy Policy</span> </li> 
                            <li><span>Terms ad Conditions</span> </li> 
                        </ul>
                    </div>
                </div>

                <div class="col-lg-6  col-md-6">
                    <div class="footer-widget">
                        <p class="footer-name">Contact Us</p>
                        <ul class="footer-contact-list">
                            <li><span>UNITED ARAB EMIRATES</span> </li> 
                            <li><span>OMAN</span> </li> 
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid p-0 copy-right-area">
            <h6 class="text-center text-white m-0 p-3">© 2025 Unikai. All Rights Reserved.</h6>
        </div>
</footer>
